import * as R from 'ramda'
import { checkToken } from '@/utils/helpers'
import Cookies from 'js-cookie'

const IK = 'ik'

/**
 * 测试站主机名以 test. 开头（test.awl.duobaby.net），正式站是 awl.duobaby.net。
 * 测试站是正式站的子域，Cookie 写在 awl.duobaby.net / .duobaby.net 上时，测试站也会带上正式票。
 */
function removeSharedIk () {
  const host = typeof window !== 'undefined' ? window.location.hostname : ''
  Cookies.remove(IK, { path: '/', domain: '.duobaby.net' })
  Cookies.remove(IK, { path: '/', domain: 'duobaby.net' })
  if (host.startsWith('test.')) {
    Cookies.remove(IK, { path: '/', domain: 'awl.duobaby.net' })
    Cookies.remove(IK, { path: '/', domain: '.awl.duobaby.net' })
  }
}

class Session {
  static get (path) {
    try {
      const serializedState = localStorage.getItem('state')
      if (serializedState === null) {
        return undefined
      }
      const state = JSON.parse(serializedState)
      if (path) {
        return R.path(path)(state)
      }
      return state
    } catch (error) {
      return undefined
    }
  }

  /**
   * 先清掉会串到另一环境的父域 ik，再读当前主机自己的 ik。
   * test.awl.duobaby.net 与 awl.duobaby.net 各留各的票。
   */
  static readHostIk () {
    removeSharedIk()
    return Cookies.get(IK) || ''
  }

  /**
   * 只写当前主机的 ik，不带 Domain。
   * 不写到 awl.duobaby.net，避免正式票被 test.awl.duobaby.net 读到。
   */
  static setIkCookie (token) {
    if (!checkToken(token)) return
    removeSharedIk()
    Cookies.set(IK, token, { expires: 7, path: '/' })
  }

  static removeIkCookie () {
    Cookies.remove(IK, { path: '/' })
    removeSharedIk()
  }

  /**
   * 人脸 BFF 只认 Cookie `ik`；业务页认 Redux / localStorage 的 ERP token。
   * 已登录但 Cookie 丢失时补写，避免 /face 401 而页面不跳登录。
   * @param {string} [token]
   */
  static ensureIkCookie (token) {
    const t = token || Session.getToken()
    Session.setIkCookie(t)
  }

  static isExpired () {
    const token = Session.getToken()
    if (checkToken(token)) {
      Session.setIkCookie(token)
    }
    return !checkToken(token)
  }

  static getToken () {
    return Session.get(['app', 'token'])
  }

  static getUserInfo () {
    return Session.get(['app', 'user'])
  }
}

export default Session
